import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { Button } from "./ui/button";
import { autoReloadIfAllowed, reloadApp } from "../lib/firestore-recovery";
import { diag } from "../lib/diag";
import { whileVisible } from "../hooks/use-slow-loading";

const SLOW_AFTER_MS = 12_000;

/**
 * Full-screen loading state. If loading takes unusually long (bad network,
 * stuck local database) it offers a reload instead of spinning forever, so
 * users don't have to force-quit the app.
 */
export default function LoadingScreen() {
  const [slow, setSlow] = useState(false);

  useEffect(
    () =>
      // Only time on screen counts (see whileVisible).
      whileVisible(() => {
        const timer = setTimeout(() => {
          diag("startup slow", { ms: SLOW_AFTER_MS });
          setSlow(true);
        }, SLOW_AFTER_MS);
        const reload = setTimeout(() => autoReloadIfAllowed("startup stuck"), 25_000);
        return () => {
          clearTimeout(timer);
          clearTimeout(reload);
        };
      }),
    []
  );

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center gap-4 px-6 text-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      {slow && (
        <div className="max-w-xs space-y-3 animate-in fade-in slide-in-from-bottom-2">
          <p className="text-sm text-muted-foreground">
            Učitavanje traje dulje nego inače. Provjerite internetsku vezu.
          </p>
          <Button variant="outline" onClick={() => reloadApp("startup retry button")}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Pokušaj ponovno
          </Button>
        </div>
      )}
    </div>
  );
}

/** Small spinner shown while a lazily loaded page is being fetched. */
export function PageSpinner() {
  return (
    <div className="flex w-full justify-center py-16">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}
